import { Typography } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthUseCase } from "@gui/contexts/useCases/UseCasesContext";

export const Logout = () => {
	const navigate = useNavigate();
	const auth = useAuthUseCase();

	useEffect(() => {
		auth.logout();
		navigate("/login", { replace: true });
	}, []);

	return <Typography> Please wait... </Typography>;
};
